import React, { useMemo } from "react";

type ColorPalettePickerProps = {
  colorKey: string;
  propsSelectedColor: string;
  isPOSA?: boolean;
  onColorSelect: (colorKey: string, hex: string) => void;
};

const ColorPalettePicker: React.FC<ColorPalettePickerProps> = (props) => {
  const palette_1 = [
    { name: "yellow", hex: "#fcbc14" },
    { name: "orange", hex: "#da4b1e" },
    { name: "blue", hex: "#3f85f4" },
    { name: "green", hex: "#59ac80" },
    { name: "red", hex: "#ff0054" }
  ];

  const palette_2 = [
    { name: "black", hex: "#000000" },
    { name: "gray", hex: "#d8d8d8" },
    { name: "white", hex: "#ffffff" },
    { name: "yellow-light", hex: "#fff1b0" },
    { name: "turquoise", hex: "#cbf4f0" }
  ];

  const palette_3 = [
    { name: "black", hex: "#000000" },
    { name: "white", hex: "#ffffff" }
  ];

  const palette = useMemo(() => {
    switch (props.colorKey) {
      case "primary":
      case "titles":
      case "subtitle":
        return palette_1;

      case "accent":
        return props.isPOSA ? palette_3 : palette_1;

      case "background":
      default:
        return palette_2;
    }
  }, [props.colorKey]);

  const handleColorClick = (hex: string) => {
    if (props.onColorSelect) {
      props.onColorSelect(props.colorKey, hex);
    }
  };

  const isHighlight = (propsSelectedColor: string, hex: string) => {
    return propsSelectedColor === hex ? "red" : "#d8d8d8";
  };

  return (
    <div className="d-flex my-2" style={{ minWidth: 140 }}>
      {palette.map((color, idx) => {
        return (
          <button
            key={color.name + idx}
            className="mr-1 rounded"
            onClick={() => handleColorClick(color.hex)}
            style={{
              backgroundColor: color.hex,
              width: 24,
              height: 24,
              border: `2px solid ${isHighlight(props.propsSelectedColor, color.hex)}`,
              borderRadius: 8
            }}
            aria-label={`Select ${color.name} color`}
          />
        );
      })}
    </div>
  );
};

export default ColorPalettePicker;
